export const environment = {
    production: true,
    ssl: true,
    name: 'demo',
    baseUrl: 'https://gw.dms.demo-v1.meksmart.com',
    homepageUrl: 'https://tms.dms.demo-v1.meksmart.com/',
    prefixApi: {
        auth: '/auth/v1',
        beApi: '/backend-api/v1',
        masterData: '/masterdata/v1'
    },
    ggAppKey: 'AIzaSyA1wCmTA6ipuz_dLECMab3vHdLMJsUmHFs',
    baseGPSUrl: 'https://dms.demo-v1.meksmart.com',
    baseSocketUrl: 'https://dms.demo-v1.meksmart.com/login',
    defaultCountryISOCode: 'IL',
    defaultAppTimezone: 'Israel',
    defaultAppLocation: {
        lat: 32.0902013,
        lng: 34.813012
    },
    baseRouteXLUrl: '',
    usernameRouteXL: '',
    passwordRouteXL: '',
    path_lang: 'https://dms.demo-v1.meksmart.com/assets/i18n/',
    linkApk: 'https://dms.demo-v1.meksmart.com/assets/app/sovigaz_live_1.0.0.apk',
    linkIos: 'https://testflight.apple.com/join/Gnpa0DTv',
    lang: [{ code: 'en', name: 'English' }, { code: 'vi', name: 'Tiếng Việt' }],
    default_avatar: './assets/images/default-user.png',
    url_avatar: 'https://gw.dms.demo-v1.meksmart.com/auth/images/'
};
